import type { Settings } from 'react-slick';

import styles from './light.module.scss';
import { Slider } from './Slider';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const defaultSliderSettings: Settings = {
  slidesToScroll: 1,
  variableWidth: false,
  infinite: true,
  swipeToSlide: true,
  dotsClass: styles.dots,
  arrows: false,
  autoplaySpeed: 7000,
};

interface SliderLightProps extends Settings {
  children: React.ReactNode;
}

export const SliderLight = ({ children, ...rest }: SliderLightProps) => (
  <Slider {...defaultSliderSettings} {...rest}>
    {children}
  </Slider>
);
